/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosCarousel, CosmosCarouselProps } from "@components/elements";

export type ImageCarouselProps = CosmosCarouselProps;

export const ImageCarousel = ({ ...props }: ImageCarouselProps): React.JSX.Element => {
	return <CosmosCarousel buttonPosition="inside" slidesInView={1} thumbnails={true} {...props} />;
};
